document.addEventListener("DOMContentLoaded", async () => {
  const {initSubLink} = await import("../components/sublink.js");
  initSubLink();
});
